import { render } from "./Footer.vue?vue&type=template&id=6eead19e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6eead19e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6eead19e"

export default script